module.exports = __webpack_public_path__ + "img/payment_pc_04.1df53eaf.png";